import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface AddressBookConfirmDialogData {
  title: string;
  message: string;
  itemName: string;
  confirmLabel: string;
}

@Component({
  selector: 'app-address-book-confirm-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  template: `
    <header class="dialog-heading">
      <span><mat-icon>delete_forever</mat-icon></span>
      <div><h2 mat-dialog-title>{{ data.title }}</h2><p>{{ data.message }}</p></div>
    </header>
    <mat-dialog-content><strong>{{ data.itemName }}</strong></mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">Abbrechen</button>
      <button mat-flat-button color="warn" type="button" (click)="dialogRef.close(true)">
        <mat-icon>delete</mat-icon>{{ data.confirmLabel }}
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    :host { display: block; color: var(--app-surface-dark, #1e293b); }
    .dialog-heading { display: flex; gap: .85rem; padding: 1.4rem 1.5rem .35rem; }
    .dialog-heading > span { display: grid; place-items: center; width: 2.6rem; height: 2.6rem; border-radius: .75rem; color: white; background: var(--app-warn, #dc3545); }
    h2[mat-dialog-title] { margin: 0; padding: 0; font-size: 1.2rem; }
    .dialog-heading p { margin: .2rem 0 0; color: var(--app-surface-light, #64748b); }
    mat-dialog-content { min-width: min(26rem, 72vw); padding-top: 1rem; }
    mat-dialog-content strong { display: block; overflow-wrap: anywhere; padding: .8rem; border-radius: .55rem; background: #fff1f2; }
    mat-dialog-actions { padding: .75rem 1.5rem 1.25rem; }
  `]
})
export class AddressBookConfirmDialogComponent {
  constructor(
    readonly dialogRef: MatDialogRef<AddressBookConfirmDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: AddressBookConfirmDialogData
  ) { }
}
